import axios from "axios";

const baseUrl = reactConfig.url;

/**
 * Send view Product page notification
 *
 * @param {number} productId
 * @param {string} productName
 *
 */
export const viewProduct = async (productId, productName) => {
    const data = {
        product_id: productId,
        product_name: productName,
    };

    try {
        const response = await axios.post(
            `${baseUrl}/event/view/product`,
            data
        );

        if (response.status !== 200) {
            throw new Error();
        }
    } catch (err) {
        return { ok: false };
    }
};

/**
 * Send view Cart page notification
 *
 * @param {number} cartId
 *
 */
export const viewCart = async (cartId) => {
    const data = {
        cart_uid: cartId,
    };

    try {
        const response = await axios.post(`${baseUrl}/event/view/cart`, data);

        if (response.status !== 200) {
            throw new Error();
        }
    } catch (err) {
        return { ok: false };
    }
};

/**
 * Send view page notification
 *
 * @param {string} pageTitle
 *
 */
export const viewPage = async (pageTitle) => {
    const data = {
        page_title: pageTitle,
    };

    try {
        const response = await axios.post(`${baseUrl}/event/view/page`, data);

        if (response.status !== 200) {
            throw new Error();
        }
    } catch (err) {
        return { ok: false };
    }
};

export const initFbClientIdentity = async (fbClientId = undefined) => {
    const data = {
        fbc: fbClientId ? fbClientId : undefined,
    };

    try {
        const response = await axios.post(`${baseUrl}/event/view/init`, data);

        if (response.status !== 200) {
            throw new Error();
        }
    } catch (err) {
        return { ok: false };
    }
};
